import FadeIn from "./FadeIn";
import { C } from "./brandTokens";

/**
 * One real story.
 * Not three quoted endorsements — one person's account of a hard season
 * and what happened when they found somewhere to take it.
 * This is what Psychology Today publishes. This is what changes minds.
 */
export default function SocialProofSection() {
  return (
    <section className="py-[140px] px-6 sm:px-10" style={{ background: C.cream }}>
      <div className="max-w-[560px] mx-auto">

        <FadeIn>
          <p
            className="font-ui mb-14"
            style={{ fontSize: 11, color: C.txt3, letterSpacing: "1.4px" }}
          >
            ONE STORY
          </p>

          <div
            className="font-heading italic text-spec-brown"
            style={{ fontSize: "clamp(18px, 2.4vw, 22px)", lineHeight: 1.92 }}
          >
            <p>
              "My husband passed in January. By March I had tried everything my
              church suggested — morning devotionals, a prayer journal, a grief
              group. None of it reached me. I was going through the motions, and
              I knew it.
            </p>
            <br />
            <p>
              A friend mentioned Eden Pages. I was skeptical of anything with
              AI in it. But I was also desperate for somewhere to put things.
            </p>
            <br />
            <p>
              I wrote one morning about how the house felt different at 6am.
              The silence. The way the chair across from me still had his shape
              in it. The companion wrote something back I've thought about every
              day since: 'You're not grieving your faith. You're grieving him.
              They're allowed to be different things.'
            </p>
            <br />
            <p>
              I've used it almost every morning for eight months. It doesn't
              fix the silence. But it gives me somewhere to take it."
            </p>
          </div>

          <div
            className="mt-14 pt-8"
            style={{ borderTop: `1px solid ${C.bdr}` }}
          >
            <p className="font-ui text-[13px] text-spec-txt3">
              — Linda W. &nbsp;·&nbsp; Non-denominational &nbsp;·&nbsp; 8 months
            </p>
          </div>
        </FadeIn>

      </div>

      <FadeIn delay={0.2}>
        <div
          className="max-w-[920px] mx-auto mt-24 pt-16"
          style={{ borderTop: `1px solid ${C.bdr}` }}
        >
          <p
            className="font-ui text-center"
            style={{
              fontSize: 11,
              color: C.txt3,
              letterSpacing: "1.4px",
              marginBottom: 40,
            }}
          >
            OTHER MORNINGS
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            <div>
              <p
                className="font-heading italic"
                style={{
                  fontSize: 16,
                  lineHeight: 1.85,
                  color: C.brown,
                  marginBottom: 16,
                }}
              >
                "I've kept a journal for twenty years. This is the first one
                that writes back in a way that actually sounds like scripture —
                not sentimentality."
              </p>
              <p
                className="font-ui"
                style={{
                  fontSize: 12,
                  color: C.txt3,
                  letterSpacing: "0.3px",
                }}
              >
                — James R. · Presbyterian · 6 months
              </p>
            </div>

            <div>
              <p
                className="font-heading italic"
                style={{
                  fontSize: 16,
                  lineHeight: 1.85,
                  color: C.brown,
                  marginBottom: 16,
                }}
              >
                "I switched personas once — from Pastor to Theologian — during
                a hard week in Galatians. Having the Greek unpacked felt like
                sitting with a seminary friend."
              </p>
              <p
                className="font-ui"
                style={{
                  fontSize: 12,
                  color: C.txt3,
                  letterSpacing: "0.3px",
                }}
              >
                — Marcus T. · Anglican · 1 year
              </p>
            </div>

            <div>
              <p
                className="font-heading italic"
                style={{
                  fontSize: 16,
                  lineHeight: 1.85,
                  color: C.brown,
                  marginBottom: 16,
                }}
              >
                "I was nervous about AI with anything spiritual. I was wrong
                about this. It's made me slower, not faster — it's made me
                actually sit with what I write."
              </p>
              <p
                className="font-ui"
                style={{
                  fontSize: 12,
                  color: C.txt3,
                  letterSpacing: "0.3px",
                }}
              >
                — Priya K. · Roman Catholic · 4 months
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>
  );
}
